export default __webpack_public_path__ + "static/seatsplanet-post-ride-f1f58029cc4c7cfe094198967776f0ed.gif";